import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './HomeButton.scss';
import { Button } from '@ver-uds/uswds-react';

interface Props {
  svg?: IconDefinition;
  link: string;
  linkText: string;
  // eslint-disable-next-line react/require-default-props
  action?(): void;
}

const HomeButton = ({ svg, link, linkText, action }: Props): JSX.Element => {
  const handleClick = (e: React.MouseEvent<HTMLElement>): void => {
    if (action) {
      e.preventDefault();
      action();
    }
  };

  return (
    <div className="desktop:grid-col tablet:grid-col-6 mobile:grid-col-12">
      <Button type="button" as="a" href={link} onClick={(e): void => handleClick(e)} className="home-button">
        {svg && <FontAwesomeIcon icon={svg} className="home-button-icon" />}
        {linkText}
      </Button>
    </div>
  );
};

HomeButton.defaultProps = { svg: '' };

export default HomeButton;
